import React from 'react';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { getLegalEntityName } from '../../../utils/formatters';

export default function FormHeader(props) {
  const {
    onClose = () => {}, isEdit, currentApplicant,
  } = props;
  return (
    <div className="application-form-header">
      <div className="breadcrumbs">
        <span className="breadcrumbs-prev">Заявитель</span>
        <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
        <span className="breadcrumbs-current">{currentApplicant?.id && isEdit ? getLegalEntityName(currentApplicant) : 'Новый заявитель'}</span>
      </div>
      <div className="close-button" onClick={onClose}>
        <Icons width={24} height={24} customIcon icon="close" />
      </div>
    </div>
  );
}
